import appGlobalScript from '/home/runner/work/apie-ionic-layout/apie-ionic-layout/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
export const globalScripts = appGlobalScript;
